// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/styles/AdminDashboard.css - FINAL MERGED VERSION */

/* ==========================================
   1. BASE LAYOUT (Desktop First)
   ========================================== */
   .admin-layout {
    display: flex;
    flex-direction: row; /* Explicitly row for desktop */
    min-height: calc(100vh - var(--navbar-height));
    background-color: var(--bg-secondary);
    position: relative;
    overflow-x: hidden; /* Prevent whole page scroll */
  }
  
  .admin-sidebar {
    width: 260px;
    flex-shrink: 0; /* Prevent sidebar from shrinking */
    background: var(--bg-primary);
    border-right: 1px solid var(--border-primary);
    padding: 2rem 0;
    display: flex;
    flex-direction: column;
    min-height: 100%; 
    z-index: 10;
    transition: transform 0.3s ease;
  }
  
  .admin-content {
    flex: 1 1; /* Take remaining space */
    min-width: 0; /* CRITICAL: Prevents tables from forcing the container to expand beyond viewport */
    padding: 2rem 2.5rem;
    background-color: var(--bg-secondary);
    display: flex;
    flex-direction: column;
  }
  
  /* Sidebar Links */
  .sidebar-section {
    margin-bottom: 1.5rem;
  }
  
  .sidebar-title {
    font-size: 0.8rem;
    font-weight: 600;
    color: var(--text-secondary);
    text-transform: uppercase;
    letter-spacing: 0.5px;
    padding: 0 1.5rem;
    margin-bottom: 1rem;
  }
  
  .sidebar-links {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  
  .sidebar-links a {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
    padding: 0.85rem 1.5rem;
    color: var(--text-secondary);
    text-decoration: none;
    font-size: 1rem;
    font-weight: 500;
    transition: all 0.2s ease;
    border-left: 3px solid transparent;
  }
  
  .sidebar-links a:hover {
    background: var(--bg-accent-light);
    color: var(--text-primary);
  }
  
  .sidebar-links a.active {
    background: var(--bg-accent-light);
    color: var(--text-accent);
    border-left-color: var(--text-accent);
    font-weight: 600;
  }
  
  .sidebar-links a svg {
    width: 18px;
    height: 18px;
    flex-shrink: 0;
    color: currentColor;
  }
  
  .notification-badge {
    background-color: var(--error-color);
    color: white;
    font-size: 0.75rem;
    font-weight: 700;
    height: 20px;
    min-width: 20px;
    padding: 0 6px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  /* ==========================================
     2. DASHBOARD WIDGETS & STATS
     ========================================== */
  .admin-stats {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 1.5rem;
    margin-bottom: 2.5rem;
  }
  
  .admin-stats .stat-card {
    padding: 1.2rem;
    background: var(--bg-primary);
    border: 1px solid var(--border-primary);
    box-shadow: var(--shadow-lg);
    border-radius: var(--border-radius-lg);
  }
  
  .admin-stats .stat-card h3 {
    font-size: 0.9rem;
    color: var(--text-secondary);
    margin-bottom: 0.5rem;
  }
  
  .admin-stats .stat-card .stat-number {
    font-size: 2rem;
    color: var(--text-accent);
    font-weight: 700;
  }
  
  .stat-card-combined {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  
  .combined-item {
    text-align: center;
    padding: 0.5rem 0;
  }
  .combined-item:first-child { border-bottom: 1px solid var(--border-primary); }
  
  .stat-card-link {
    text-decoration: none;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: var(--bg-accent-light);
    border: 1px solid var(--border-accent);
    border-radius: var(--border-radius-lg);
    transition: transform 0.2s;
    box-shadow: var(--shadow-lg);
    padding: 1.2rem;
  }
  .stat-card-link:hover {
    transform: translateY(-3px);
  }
  .stat-card-link h3 {
    color: var(--text-accent);
    font-size: 1.1rem;
    margin-bottom: 0.5rem;
  }
  .stat-card-link .stat-description {
    margin-top: 0.5rem;
    color: var(--text-secondary);
    font-size: 0.85rem;
  }
  
  /* ==========================================
     3. TABLES & SCROLLING
     ========================================== */
  .admin-table-container {
    background: var(--bg-primary);
    border-radius: var(--border-radius-xl);
    padding: 1.5rem;
    border: 1px solid var(--border-primary);
    box-shadow: var(--shadow-xl);
    margin-bottom: 1.5rem;
    display: flex;
    flex-direction: column;
  }
  
  .admin-table-container h3 {
    color: var(--text-primary);
    font-size: 1.25rem;
    margin-bottom: 1.5rem;
  }
  
  /* Main Page Table Wrapper */
  .table-responsive {
    display: block;
    width: 100%;
    overflow-x: auto; /* Allow horizontal scroll */
    -webkit-overflow-scrolling: touch;
    margin-bottom: 1rem;
    border-radius: var(--border-radius-lg);
    border: 1px solid var(--border-primary);
  }
  
  /* Widget/Modal Table Wrapper */
  .table-wrapper {
    display: block;
    width: 100%;
    max-height: 300px;
    overflow-y: auto; /* Vertical Scroll */
    overflow-x: auto; /* Horizontal Scroll */
    -webkit-overflow-scrolling: touch;
    border: 1px solid var(--border-primary);
    border-radius: var(--border-radius-lg);
    background-color: var(--bg-secondary);
    margin-top: 1rem;
  }
  
  /* Table Styles */
  .admin-table, 
  .table-wrapper table {
    width: 100%;
    min-width: 600px; /* Force scroll on screens smaller than 600px */
    border-collapse: collapse;
  }
  
  .admin-table th, .admin-table td,
  .table-wrapper th, .table-wrapper td {
    padding: 0.8rem 1rem;
    text-align: left;
    border-bottom: 1px solid var(--border-primary);
    white-space: nowrap; /* Prevents wrapping */
  }
  
  .admin-table th {
    background-color: var(--bg-secondary);
    color: var(--text-secondary);
    font-size: 0.8rem;
    text-transform: uppercase;
    font-weight: 600;
  }
  
  /* Mini Table (Widget) Specifics */
  .mini-table th {
    font-weight: 600;
    color: var(--text-primary);
    position: sticky;
    top: 0;
    background: var(--bg-secondary);
    z-index: 5;
  }
  .mini-table tr.suspicious td {
    color: var(--error-color);
    background-color: var(--error-bg-light);
  }
  
  /* ==========================================
     4. UI ELEMENTS (Badges, Buttons)
     ========================================== */
  .status-badge {
    padding: 0.3rem 0.7rem;
    border-radius: var(--border-radius-full);
    font-size: 0.8rem;
    font-weight: 600;
    text-transform: capitalize;
  }
  .status-badge.active { background: var(--success-bg-light); color: var(--success-color); }
  .status-badge.inactive { background: var(--error-bg-light); color: var(--error-color); }
  
  .action-button {
    background: var(--bg-secondary);
    color: var(--text-secondary);
    border: 1px solid var(--border-primary);
    padding: 0.4rem 0.8rem;
    font-size: 0.8rem;
    border-radius: var(--border-radius-lg);
    cursor: pointer;
    transition: all 0.2s ease;
  }
  .action-button:hover {
    background: var(--text-accent);
    color: var(--text-on-gradient);
    border-color: var(--text-accent);
  }
  .action-button.success:hover { background: var(--success-color); color: white; }
  .action-button.danger:hover { background: var(--error-color); color: white; }
  
  .pagination-container {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: 1.5rem;
    padding-top: 1rem;
    border-top: 1px solid var(--border-primary);
  }
  .pagination-button {
    background: var(--bg-secondary);
    border: 1px solid var(--border-primary);
    padding: 0.5rem 1rem;
    border-radius: var(--border-radius-lg);
    cursor: pointer;
  }
  .pagination-button:disabled { opacity: 0.5; cursor: not-allowed; }
  
  /* ==========================================
     5. ADMIN ACTIONS (Forms & Cards)
     ========================================== */
  .admin-action-card {
    margin-top: 2rem;
    /* Inherits .admin-table-container styles */
  }
  
  .admin-action-card h3 {
    color: var(--text-primary);
    font-size: 1.25rem;
    margin-bottom: 0.5rem;
  }
  
  .admin-action-description {
    color: var(--text-secondary);
    font-size: 0.95rem;
    margin-bottom: 2rem;
    line-height: 1.5;
  }
  
  .action-form-grid {
    display: grid;
    grid-template-columns: 1fr 1fr 2fr 1fr;
    gap: 1.5rem;
    align-items: flex-end;
  }
  
  .action-form-grid label,
  .action-form-vertical label {
    display: block;
    margin-bottom: 0.5rem;
    color: var(--text-primary);
    font-size: 0.875rem;
    font-weight: 500;
  }
  
  .action-form-grid input,
  .action-form-vertical input,
  .action-form-vertical textarea {
    width: 100%;
    padding: 0.75rem 1rem;
    border: 1px solid var(--border-primary);
    border-radius: var(--border-radius-lg);
    background: var(--bg-secondary);
    color: var(--text-primary);
    font-size: 1rem;
    box-sizing: border-box;
  }
  
  .action-form-grid input:focus,
  .action-form-vertical input:focus,
  .action-form-vertical textarea:focus {
    outline: none;
    border-color: var(--text-accent);
    box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.1);
    background: var(--bg-primary);
  }
  
  .action-form-grid .action-button {
    width: 100%;
    padding: 0.75rem 1rem;
    font-size: 0.95rem;
    font-weight: 600;
  }
  
  .action-form-vertical {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
  
  .action-button-container-right {
    display: flex;
    justify-content: flex-end;
    margin-top: 1rem;
  }
  .action-button-container-right .action-button.danger {
    background: var(--error-color);
    color: white;
    border: none;
    padding: 0.75rem 1.5rem;
  }
  
  .admin-action-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 1.5rem;
    margin-top: 2rem;
  }
  
  .admin-action-card.utility {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  
  .action-card-content p {
    font-size: 0.9rem;
    color: var(--text-secondary);
    margin-bottom: 1rem;
  }
  
  .action-card-button {
    border-top: 1px solid var(--border-primary);
    padding-top: 1.5rem;
    margin-top: 1rem;
  }
  .action-card-button .action-button {
    width: 100%;
    padding: 0.7rem 1rem;
  }
  
  .admin-section-title {
    font-size: 1.5rem;
    font-weight: 600;
    color: var(--text-primary);
    margin-top: 3rem;
    margin-bottom: 1rem;
    padding-bottom: 0.5rem;
    border-bottom: 1px solid var(--border-primary);
  }
  
  /* Success/Error Messages in Cards */
  .admin-action-card .success-message,
  .admin-action-card .error-message {
    padding: 1rem;
    border-radius: var(--border-radius-lg);
    margin: 1rem 0;
    text-align: center;
    font-size: 0.9rem;
  }
  .admin-action-card .success-message { background: var(--success-bg-light); color: var(--success-color); border: 1px solid var(--success-color); }
  .admin-action-card .error-message { background: var(--error-bg-light); color: var(--error-color); border: 1px solid var(--error-color); }
  
  /* ==========================================
     6. SEARCH BAR & HEADERS
     ========================================== */
  .table-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1.5rem;
  }
  
  .search-bar input {
    padding: 0.5rem 0.8rem;
    border: 1px solid var(--border-primary);
    border-radius: var(--border-radius-lg);
    background-color: var(--bg-secondary);
    width: 250px;
  }
  
  /* ==========================================
     7. MODALS & OVERLAYS
     ========================================== */
  .modal-content.large {
    max-width: 900px;
    max-height: 90vh;
    display: flex;
    flex-direction: column;
  }
  
  .security-details-grid {
    margin-top: 1.5rem;
    display: grid;
    gap: 2rem;
    overflow-y: auto;
    flex-shrink: 1;
    padding: 2px 10px 2px 2px;
  }
  
  .detail-section h4 {
    font-size: 1.1rem;
    color: var(--text-accent);
    margin-bottom: 1rem;
    padding-bottom: 0.5rem;
    border-bottom: 1px solid var(--border-primary);
  }
  
  /* ==========================================
     8. MOBILE RESPONSIVENESS
     ========================================== */
  
  /* Default Hidden Mobile Elements */
  .admin-mobile-toggle, 
  .admin-sidebar-overlay, 
  .sidebar-header-mobile {
    display: none;
  }
  
  /* Tablet (992px) */
  @media (max-width: 992px) {
    .admin-stats { grid-template-columns: repeat(2, 1fr); }
    .usage-tracking-grid { grid-template-columns: 1fr; }
    .action-form-grid { grid-template-columns: 1fr 1fr; }
    .action-form-grid .reason-group, .action-form-grid .action-button-container { grid-column: span 2; }
  }
  
  /* Mobile (768px) */
  @media (max-width: 768px) {
    /* Layout Reset */
    .admin-layout {
      flex-direction: column;
    }
  
    /* Sidebar becomes a drawer */
    .admin-sidebar {
      position: fixed;
      top: var(--navbar-height);
      left: -280px; /* Hidden by default */
      bottom: 0;
      width: 280px;
      transition: left 0.3s ease-in-out;
      box-shadow: 2px 0 10px rgba(0,0,0,0.2);
      border-right: none;
    }
  
    .admin-sidebar.open {
      left: 0; /* Slide in */
    }
  
    /* Overlay */
    .admin-sidebar-overlay {
      display: block;
      position: fixed;
      top: 0; left: 0; right: 0; bottom: 0;
      background: rgba(0,0,0,0.5);
      z-index: 9;
      opacity: 0;
      pointer-events: none;
      transition: opacity 0.3s ease;
    }
    .admin-sidebar-overlay.open {
      opacity: 1;
      pointer-events: auto;
    }
  
    /* Main Content */
    .admin-content {
      width: 100%;
      padding: 1rem;
      margin-top: 3rem; /* Space for toggle button */
    }
  
    /* Toggle Button */
    .admin-mobile-toggle {
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      top: 1rem;
      left: 1rem;
      z-index: 5;
      background: var(--bg-primary);
      border: 1px solid var(--border-primary);
      padding: 0.5rem 1rem;
      border-radius: 8px;
      font-weight: 600;
      cursor: pointer;
      box-shadow: var(--shadow-lg);
    }
  
    /* Mobile Header inside Sidebar */
    .sidebar-header-mobile {
      display: block;
      padding: 0 1.5rem 1rem;
      border-bottom: 1px solid var(--border-primary);
      margin-bottom: 1rem;
    }
    .sidebar-header-mobile h3 { margin: 0; font-size: 1.2rem; }
  
    /* Stack Grids */
    .admin-stats { grid-template-columns: 1fr; }
    .action-form-grid { grid-template-columns: 1fr; }
    .action-form-grid .reason-group, .action-form-grid .action-button-container { grid-column: span 1; }
    
    /* Stack Header Elements */
    .table-header {
      flex-direction: column;
      align-items: stretch;
      gap: 1rem;
    }
    .search-bar input { width: 100%; }
    
    .date-range-container {
      flex-direction: column;
      align-items: stretch;
    }
    .admin-action-grid {
      grid-template-columns: 1fr;
    }
  }
  
  /* Small Mobile (500px) */
  @media (max-width: 500px) {
    .admin-table-container { padding: 1rem; }
    
    /* Modal Adjustments */
    .user-details-grid {
      grid-template-columns: 1fr;
      gap: 0.5rem;
    }
    .modal-actions {
      flex-direction: column;
    }
    .modal-actions button {
      width: 100%;
    }
  }`, "",{"version":3,"sources":["webpack://./src/styles/AdminDashboard.css"],"names":[],"mappings":"AAAA,yDAAyD;;AAEzD;;+CAE+C;GAC5C;IACC,aAAa;IACb,mBAAmB,EAAE,+BAA+B;IACpD,8CAA8C;IAC9C,qCAAqC;IACrC,kBAAkB;IAClB,kBAAkB,EAAE,8BAA8B;EACpD;;EAEA;IACE,YAAY;IACZ,cAAc,EAAE,mCAAmC;IACnD,6BAA6B;IAC7B,6CAA6C;IAC7C,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,WAAW;IACX,+BAA+B;EACjC;;EAEA;IACE,SAAO,EAAE,yBAAyB;IAClC,YAAY,EAAE,mFAAmF;IACjG,oBAAoB;IACpB,qCAAqC;IACrC,aAAa;IACb,sBAAsB;EACxB;;EAEA,kBAAkB;EAClB;IACE,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,4BAA4B;IAC5B,yBAAyB;IACzB,qBAAqB;IACrB,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,UAAU;IACV,SAAS;EACX;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,YAAY;IACZ,uBAAuB;IACvB,4BAA4B;IAC5B,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,kCAAkC;EACpC;;EAEA;IACE,kCAAkC;IAClC,0BAA0B;EAC5B;;EAEA;IACE,kCAAkC;IAClC,yBAAyB;IACzB,qCAAqC;IACrC,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,oCAAoC;IACpC,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;;iDAE+C;EAC/C;IACE,aAAa;IACb,qCAAqC;IACrC,WAAW;IACX,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,6BAA6B;IAC7B,uCAAuC;IACvC,4BAA4B;IAC5B,sCAAsC;EACxC;;EAEA;IACE,iBAAiB;IACjB,4BAA4B;IAC5B,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,8BAA8B;EAChC;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;EACA,6BAA6B,8CAA8C,EAAE;;EAE7E;IACE,qBAAqB;IACrB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,kCAAkC;IAClC,sCAAsC;IACtC,sCAAsC;IACtC,0BAA0B;IAC1B,4BAA4B;IAC5B,eAAe;EACjB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,yBAAyB;IACzB,iBAAiB;IACjB,qBAAqB;EACvB;EACA;IACE,kBAAkB;IAClB,4BAA4B;IAC5B,kBAAkB;EACpB;;EAEA;;iDAE+C;EAC/C;IACE,6BAA6B;IAC7B,sCAAsC;IACtC,eAAe;IACf,uCAAuC;IACvC,4BAA4B;IAC5B,qBAAqB;IACrB,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;IAC1B,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA,4BAA4B;EAC5B;IACE,cAAc;IACd,WAAW;IACX,gBAAgB,EAAE,4BAA4B;IAC9C,iCAAiC;IACjC,mBAAmB;IACnB,sCAAsC;IACtC,uCAAuC;EACzC;;EAEA,+BAA+B;EAC/B;IACE,cAAc;IACd,WAAW;IACX,iBAAiB;IACjB,gBAAgB,EAAE,oBAAoB;IACtC,gBAAgB,EAAE,sBAAsB;IACxC,iCAAiC;IACjC,uCAAuC;IACvC,sCAAsC;IACtC,qCAAqC;IACrC,gBAAgB;EAClB;;EAEA,iBAAiB;EACjB;;IAEE,WAAW;IACX,gBAAgB,EAAE,+CAA+C;IACjE,yBAAyB;EAC3B;;EAEA;;IAEE,oBAAoB;IACpB,gBAAgB;IAChB,8CAA8C;IAC9C,mBAAmB,EAAE,sBAAsB;EAC7C;;EAEA;IACE,qCAAqC;IACrC,4BAA4B;IAC5B,iBAAiB;IACjB,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA,kCAAkC;EAClC;IACE,gBAAgB;IAChB,0BAA0B;IAC1B,gBAAgB;IAChB,MAAM;IACN,+BAA+B;IAC/B,UAAU;EACZ;EACA;IACE,yBAAyB;IACzB,uCAAuC;EACzC;;EAEA;;iDAE+C;EAC/C;IACE,sBAAsB;IACtB,wCAAwC;IACxC,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;EAC5B;EACA,uBAAuB,mCAAmC,EAAE,2BAA2B,EAAE;EACzF,yBAAyB,iCAAiC,EAAE,yBAAyB,EAAE;;EAEvF;IACE,+BAA+B;IAC/B,4BAA4B;IAC5B,uCAAuC;IACvC,sBAAsB;IACtB,iBAAiB;IACjB,sCAAsC;IACtC,eAAe;IACf,yBAAyB;EAC3B;EACA;IACE,8BAA8B;IAC9B,8BAA8B;IAC9B,gCAAgC;EAClC;EACA,+BAA+B,gCAAgC,EAAE,YAAY,EAAE;EAC/E,8BAA8B,8BAA8B,EAAE,YAAY,EAAE;;EAE5E;IACE,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,2CAA2C;EAC7C;EACA;IACE,+BAA+B;IAC/B,uCAAuC;IACvC,oBAAoB;IACpB,sCAAsC;IACtC,eAAe;EACjB;EACA,8BAA8B,YAAY,EAAE,mBAAmB,EAAE;;EAEjE;;iDAE+C;EAC/C;IACE,gBAAgB;IAChB,2CAA2C;EAC7C;;EAEA;IACE,0BAA0B;IAC1B,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,4BAA4B;IAC5B,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,sCAAsC;IACtC,WAAW;IACX,qBAAqB;EACvB;;EAEA;;IAEE,cAAc;IACd,qBAAqB;IACrB,0BAA0B;IAC1B,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;;;IAGE,WAAW;IACX,qBAAqB;IACrB,uCAAuC;IACvC,sCAAsC;IACtC,+BAA+B;IAC/B,0BAA0B;IAC1B,eAAe;IACf,sBAAsB;EACxB;;EAEA;;;IAGE,aAAa;IACb,gCAAgC;IAChC,4CAA4C;IAC5C,6BAA6B;EAC/B;;EAEA;IACE,WAAW;IACX,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,yBAAyB;IACzB,gBAAgB;EAClB;EACA;IACE,8BAA8B;IAC9B,YAAY;IACZ,YAAY;IACZ,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,2DAA2D;IAC3D,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,8BAA8B;EAChC;;EAEA;IACE,iBAAiB;IACjB,4BAA4B;IAC5B,mBAAmB;EACrB;;EAEA;IACE,2CAA2C;IAC3C,mBAAmB;IACnB,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;IAC1B,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;IACtB,8CAA8C;EAChD;;EAEA,oCAAoC;EACpC;;IAEE,aAAa;IACb,sCAAsC;IACtC,cAAc;IACd,kBAAkB;IAClB,iBAAiB;EACnB;EACA,sCAAsC,mCAAmC,EAAE,2BAA2B,EAAE,sCAAsC,EAAE;EAChJ,oCAAoC,iCAAiC,EAAE,yBAAyB,EAAE,oCAAoC,EAAE;;EAExI;;iDAE+C;EAC/C;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;IACtB,uCAAuC;IACvC,sCAAsC;IACtC,qCAAqC;IACrC,YAAY;EACd;;EAEA;;iDAE+C;EAC/C;IACE,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,SAAS;IACT,gBAAgB;IAChB,cAAc;IACd,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,sBAAsB;IACtB,8CAA8C;EAChD;;EAEA;;iDAE+C;;EAE/C,mCAAmC;EACnC;;;IAGE,aAAa;EACf;;EAEA,mBAAmB;EACnB;IACE,eAAe,qCAAqC,EAAE;IACtD,uBAAuB,0BAA0B,EAAE;IACnD,oBAAoB,8BAA8B,EAAE;IACpD,8EAA8E,mBAAmB,EAAE;EACrG;;EAEA,mBAAmB;EACnB;IACE,iBAAiB;IACjB;MACE,sBAAsB;IACxB;;IAEA,6BAA6B;IAC7B;MACE,eAAe;MACf,yBAAyB;MACzB,YAAY,EAAE,sBAAsB;MACpC,SAAS;MACT,YAAY;MACZ,iCAAiC;MACjC,sCAAsC;MACtC,kBAAkB;IACpB;;IAEA;MACE,OAAO,EAAE,aAAa;IACxB;;IAEA,YAAY;IACZ;MACE,cAAc;MACd,eAAe;MACf,MAAM,EAAE,OAAO,EAAE,QAAQ,EAAE,SAAS;MACpC,2BAA2B;MAC3B,UAAU;MACV,UAAU;MACV,oBAAoB;MACpB,6BAA6B;IAC/B;IACA;MACE,UAAU;MACV,oBAAoB;IACtB;;IAEA,iBAAiB;IACjB;MACE,WAAW;MACX,aAAa;MACb,gBAAgB,EAAE,4BAA4B;IAChD;;IAEA,kBAAkB;IAClB;MACE,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,kBAAkB;MAClB,SAAS;MACT,UAAU;MACV,UAAU;MACV,6BAA6B;MAC7B,uCAAuC;MACvC,oBAAoB;MACpB,kBAAkB;MAClB,gBAAgB;MAChB,eAAe;MACf,4BAA4B;IAC9B;;IAEA,iCAAiC;IACjC;MACE,cAAc;MACd,sBAAsB;MACtB,8CAA8C;MAC9C,mBAAmB;IACrB;IACA,4BAA4B,SAAS,EAAE,iBAAiB,EAAE;;IAE1D,gBAAgB;IAChB,eAAe,0BAA0B,EAAE;IAC3C,oBAAoB,0BAA0B,EAAE;IAChD,8EAA8E,mBAAmB,EAAE;;IAEnG,0BAA0B;IAC1B;MACE,sBAAsB;MACtB,oBAAoB;MACpB,SAAS;IACX;IACA,oBAAoB,WAAW,EAAE;;IAEjC;MACE,sBAAsB;MACtB,oBAAoB;IACtB;IACA;MACE,0BAA0B;IAC5B;EACF;;EAEA,yBAAyB;EACzB;IACE,yBAAyB,aAAa,EAAE;;IAExC,sBAAsB;IACtB;MACE,0BAA0B;MAC1B,WAAW;IACb;IACA;MACE,sBAAsB;IACxB;IACA;MACE,WAAW;IACb;EACF","sourcesContent":["/* src/styles/AdminDashboard.css - FINAL MERGED VERSION */\n\n/* ==========================================\n   1. BASE LAYOUT (Desktop First)\n   ========================================== */\n   .admin-layout {\n    display: flex;\n    flex-direction: row; /* Explicitly row for desktop */\n    min-height: calc(100vh - var(--navbar-height));\n    background-color: var(--bg-secondary);\n    position: relative;\n    overflow-x: hidden; /* Prevent whole page scroll */\n  }\n  \n  .admin-sidebar {\n    width: 260px;\n    flex-shrink: 0; /* Prevent sidebar from shrinking */\n    background: var(--bg-primary);\n    border-right: 1px solid var(--border-primary);\n    padding: 2rem 0;\n    display: flex;\n    flex-direction: column;\n    min-height: 100%; \n    z-index: 10;\n    transition: transform 0.3s ease;\n  }\n  \n  .admin-content {\n    flex: 1; /* Take remaining space */\n    min-width: 0; /* CRITICAL: Prevents tables from forcing the container to expand beyond viewport */\n    padding: 2rem 2.5rem;\n    background-color: var(--bg-secondary);\n    display: flex;\n    flex-direction: column;\n  }\n  \n  /* Sidebar Links */\n  .sidebar-section {\n    margin-bottom: 1.5rem;\n  }\n  \n  .sidebar-title {\n    font-size: 0.8rem;\n    font-weight: 600;\n    color: var(--text-secondary);\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    padding: 0 1.5rem;\n    margin-bottom: 1rem;\n  }\n  \n  .sidebar-links {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n  }\n  \n  .sidebar-links a {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 0.75rem;\n    padding: 0.85rem 1.5rem;\n    color: var(--text-secondary);\n    text-decoration: none;\n    font-size: 1rem;\n    font-weight: 500;\n    transition: all 0.2s ease;\n    border-left: 3px solid transparent;\n  }\n  \n  .sidebar-links a:hover {\n    background: var(--bg-accent-light);\n    color: var(--text-primary);\n  }\n  \n  .sidebar-links a.active {\n    background: var(--bg-accent-light);\n    color: var(--text-accent);\n    border-left-color: var(--text-accent);\n    font-weight: 600;\n  }\n  \n  .sidebar-links a svg {\n    width: 18px;\n    height: 18px;\n    flex-shrink: 0;\n    color: currentColor;\n  }\n  \n  .notification-badge {\n    background-color: var(--error-color);\n    color: white;\n    font-size: 0.75rem;\n    font-weight: 700;\n    height: 20px;\n    min-width: 20px;\n    padding: 0 6px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  \n  /* ==========================================\n     2. DASHBOARD WIDGETS & STATS\n     ========================================== */\n  .admin-stats {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 1.5rem;\n    margin-bottom: 2.5rem;\n  }\n  \n  .admin-stats .stat-card {\n    padding: 1.2rem;\n    background: var(--bg-primary);\n    border: 1px solid var(--border-primary);\n    box-shadow: var(--shadow-lg);\n    border-radius: var(--border-radius-lg);\n  }\n  \n  .admin-stats .stat-card h3 {\n    font-size: 0.9rem;\n    color: var(--text-secondary);\n    margin-bottom: 0.5rem;\n  }\n  \n  .admin-stats .stat-card .stat-number {\n    font-size: 2rem;\n    color: var(--text-accent);\n    font-weight: 700;\n  }\n  \n  .stat-card-combined {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n  }\n  \n  .combined-item {\n    text-align: center;\n    padding: 0.5rem 0;\n  }\n  .combined-item:first-child { border-bottom: 1px solid var(--border-primary); }\n  \n  .stat-card-link {\n    text-decoration: none;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    background: var(--bg-accent-light);\n    border: 1px solid var(--border-accent);\n    border-radius: var(--border-radius-lg);\n    transition: transform 0.2s;\n    box-shadow: var(--shadow-lg);\n    padding: 1.2rem;\n  }\n  .stat-card-link:hover {\n    transform: translateY(-3px);\n  }\n  .stat-card-link h3 {\n    color: var(--text-accent);\n    font-size: 1.1rem;\n    margin-bottom: 0.5rem;\n  }\n  .stat-card-link .stat-description {\n    margin-top: 0.5rem;\n    color: var(--text-secondary);\n    font-size: 0.85rem;\n  }\n  \n  /* ==========================================\n     3. TABLES & SCROLLING\n     ========================================== */\n  .admin-table-container {\n    background: var(--bg-primary);\n    border-radius: var(--border-radius-xl);\n    padding: 1.5rem;\n    border: 1px solid var(--border-primary);\n    box-shadow: var(--shadow-xl);\n    margin-bottom: 1.5rem;\n    display: flex;\n    flex-direction: column;\n  }\n  \n  .admin-table-container h3 {\n    color: var(--text-primary);\n    font-size: 1.25rem;\n    margin-bottom: 1.5rem;\n  }\n  \n  /* Main Page Table Wrapper */\n  .table-responsive {\n    display: block;\n    width: 100%;\n    overflow-x: auto; /* Allow horizontal scroll */\n    -webkit-overflow-scrolling: touch;\n    margin-bottom: 1rem;\n    border-radius: var(--border-radius-lg);\n    border: 1px solid var(--border-primary);\n  }\n  \n  /* Widget/Modal Table Wrapper */\n  .table-wrapper {\n    display: block;\n    width: 100%;\n    max-height: 300px;\n    overflow-y: auto; /* Vertical Scroll */\n    overflow-x: auto; /* Horizontal Scroll */\n    -webkit-overflow-scrolling: touch;\n    border: 1px solid var(--border-primary);\n    border-radius: var(--border-radius-lg);\n    background-color: var(--bg-secondary);\n    margin-top: 1rem;\n  }\n  \n  /* Table Styles */\n  .admin-table, \n  .table-wrapper table {\n    width: 100%;\n    min-width: 600px; /* Force scroll on screens smaller than 600px */\n    border-collapse: collapse;\n  }\n  \n  .admin-table th, .admin-table td,\n  .table-wrapper th, .table-wrapper td {\n    padding: 0.8rem 1rem;\n    text-align: left;\n    border-bottom: 1px solid var(--border-primary);\n    white-space: nowrap; /* Prevents wrapping */\n  }\n  \n  .admin-table th {\n    background-color: var(--bg-secondary);\n    color: var(--text-secondary);\n    font-size: 0.8rem;\n    text-transform: uppercase;\n    font-weight: 600;\n  }\n  \n  /* Mini Table (Widget) Specifics */\n  .mini-table th {\n    font-weight: 600;\n    color: var(--text-primary);\n    position: sticky;\n    top: 0;\n    background: var(--bg-secondary);\n    z-index: 5;\n  }\n  .mini-table tr.suspicious td {\n    color: var(--error-color);\n    background-color: var(--error-bg-light);\n  }\n  \n  /* ==========================================\n     4. UI ELEMENTS (Badges, Buttons)\n     ========================================== */\n  .status-badge {\n    padding: 0.3rem 0.7rem;\n    border-radius: var(--border-radius-full);\n    font-size: 0.8rem;\n    font-weight: 600;\n    text-transform: capitalize;\n  }\n  .status-badge.active { background: var(--success-bg-light); color: var(--success-color); }\n  .status-badge.inactive { background: var(--error-bg-light); color: var(--error-color); }\n  \n  .action-button {\n    background: var(--bg-secondary);\n    color: var(--text-secondary);\n    border: 1px solid var(--border-primary);\n    padding: 0.4rem 0.8rem;\n    font-size: 0.8rem;\n    border-radius: var(--border-radius-lg);\n    cursor: pointer;\n    transition: all 0.2s ease;\n  }\n  .action-button:hover {\n    background: var(--text-accent);\n    color: var(--text-on-gradient);\n    border-color: var(--text-accent);\n  }\n  .action-button.success:hover { background: var(--success-color); color: white; }\n  .action-button.danger:hover { background: var(--error-color); color: white; }\n  \n  .pagination-container {\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    margin-top: 1.5rem;\n    padding-top: 1rem;\n    border-top: 1px solid var(--border-primary);\n  }\n  .pagination-button {\n    background: var(--bg-secondary);\n    border: 1px solid var(--border-primary);\n    padding: 0.5rem 1rem;\n    border-radius: var(--border-radius-lg);\n    cursor: pointer;\n  }\n  .pagination-button:disabled { opacity: 0.5; cursor: not-allowed; }\n  \n  /* ==========================================\n     5. ADMIN ACTIONS (Forms & Cards)\n     ========================================== */\n  .admin-action-card {\n    margin-top: 2rem;\n    /* Inherits .admin-table-container styles */\n  }\n  \n  .admin-action-card h3 {\n    color: var(--text-primary);\n    font-size: 1.25rem;\n    margin-bottom: 0.5rem;\n  }\n  \n  .admin-action-description {\n    color: var(--text-secondary);\n    font-size: 0.95rem;\n    margin-bottom: 2rem;\n    line-height: 1.5;\n  }\n  \n  .action-form-grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr 2fr 1fr;\n    gap: 1.5rem;\n    align-items: flex-end;\n  }\n  \n  .action-form-grid label,\n  .action-form-vertical label {\n    display: block;\n    margin-bottom: 0.5rem;\n    color: var(--text-primary);\n    font-size: 0.875rem;\n    font-weight: 500;\n  }\n  \n  .action-form-grid input,\n  .action-form-vertical input,\n  .action-form-vertical textarea {\n    width: 100%;\n    padding: 0.75rem 1rem;\n    border: 1px solid var(--border-primary);\n    border-radius: var(--border-radius-lg);\n    background: var(--bg-secondary);\n    color: var(--text-primary);\n    font-size: 1rem;\n    box-sizing: border-box;\n  }\n  \n  .action-form-grid input:focus,\n  .action-form-vertical input:focus,\n  .action-form-vertical textarea:focus {\n    outline: none;\n    border-color: var(--text-accent);\n    box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.1);\n    background: var(--bg-primary);\n  }\n  \n  .action-form-grid .action-button {\n    width: 100%;\n    padding: 0.75rem 1rem;\n    font-size: 0.95rem;\n    font-weight: 600;\n  }\n  \n  .action-form-vertical {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n  }\n  \n  .action-button-container-right {\n    display: flex;\n    justify-content: flex-end;\n    margin-top: 1rem;\n  }\n  .action-button-container-right .action-button.danger {\n    background: var(--error-color);\n    color: white;\n    border: none;\n    padding: 0.75rem 1.5rem;\n  }\n  \n  .admin-action-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n    gap: 1.5rem;\n    margin-top: 2rem;\n  }\n  \n  .admin-action-card.utility {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n  }\n  \n  .action-card-content p {\n    font-size: 0.9rem;\n    color: var(--text-secondary);\n    margin-bottom: 1rem;\n  }\n  \n  .action-card-button {\n    border-top: 1px solid var(--border-primary);\n    padding-top: 1.5rem;\n    margin-top: 1rem;\n  }\n  .action-card-button .action-button {\n    width: 100%;\n    padding: 0.7rem 1rem;\n  }\n  \n  .admin-section-title {\n    font-size: 1.5rem;\n    font-weight: 600;\n    color: var(--text-primary);\n    margin-top: 3rem;\n    margin-bottom: 1rem;\n    padding-bottom: 0.5rem;\n    border-bottom: 1px solid var(--border-primary);\n  }\n  \n  /* Success/Error Messages in Cards */\n  .admin-action-card .success-message,\n  .admin-action-card .error-message {\n    padding: 1rem;\n    border-radius: var(--border-radius-lg);\n    margin: 1rem 0;\n    text-align: center;\n    font-size: 0.9rem;\n  }\n  .admin-action-card .success-message { background: var(--success-bg-light); color: var(--success-color); border: 1px solid var(--success-color); }\n  .admin-action-card .error-message { background: var(--error-bg-light); color: var(--error-color); border: 1px solid var(--error-color); }\n  \n  /* ==========================================\n     6. SEARCH BAR & HEADERS\n     ========================================== */\n  .table-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 1.5rem;\n  }\n  \n  .search-bar input {\n    padding: 0.5rem 0.8rem;\n    border: 1px solid var(--border-primary);\n    border-radius: var(--border-radius-lg);\n    background-color: var(--bg-secondary);\n    width: 250px;\n  }\n  \n  /* ==========================================\n     7. MODALS & OVERLAYS\n     ========================================== */\n  .modal-content.large {\n    max-width: 900px;\n    max-height: 90vh;\n    display: flex;\n    flex-direction: column;\n  }\n  \n  .security-details-grid {\n    margin-top: 1.5rem;\n    display: grid;\n    gap: 2rem;\n    overflow-y: auto;\n    flex-shrink: 1;\n    padding: 2px 10px 2px 2px;\n  }\n  \n  .detail-section h4 {\n    font-size: 1.1rem;\n    color: var(--text-accent);\n    margin-bottom: 1rem;\n    padding-bottom: 0.5rem;\n    border-bottom: 1px solid var(--border-primary);\n  }\n  \n  /* ==========================================\n     8. MOBILE RESPONSIVENESS\n     ========================================== */\n  \n  /* Default Hidden Mobile Elements */\n  .admin-mobile-toggle, \n  .admin-sidebar-overlay, \n  .sidebar-header-mobile {\n    display: none;\n  }\n  \n  /* Tablet (992px) */\n  @media (max-width: 992px) {\n    .admin-stats { grid-template-columns: repeat(2, 1fr); }\n    .usage-tracking-grid { grid-template-columns: 1fr; }\n    .action-form-grid { grid-template-columns: 1fr 1fr; }\n    .action-form-grid .reason-group, .action-form-grid .action-button-container { grid-column: span 2; }\n  }\n  \n  /* Mobile (768px) */\n  @media (max-width: 768px) {\n    /* Layout Reset */\n    .admin-layout {\n      flex-direction: column;\n    }\n  \n    /* Sidebar becomes a drawer */\n    .admin-sidebar {\n      position: fixed;\n      top: var(--navbar-height);\n      left: -280px; /* Hidden by default */\n      bottom: 0;\n      width: 280px;\n      transition: left 0.3s ease-in-out;\n      box-shadow: 2px 0 10px rgba(0,0,0,0.2);\n      border-right: none;\n    }\n  \n    .admin-sidebar.open {\n      left: 0; /* Slide in */\n    }\n  \n    /* Overlay */\n    .admin-sidebar-overlay {\n      display: block;\n      position: fixed;\n      top: 0; left: 0; right: 0; bottom: 0;\n      background: rgba(0,0,0,0.5);\n      z-index: 9;\n      opacity: 0;\n      pointer-events: none;\n      transition: opacity 0.3s ease;\n    }\n    .admin-sidebar-overlay.open {\n      opacity: 1;\n      pointer-events: auto;\n    }\n  \n    /* Main Content */\n    .admin-content {\n      width: 100%;\n      padding: 1rem;\n      margin-top: 3rem; /* Space for toggle button */\n    }\n  \n    /* Toggle Button */\n    .admin-mobile-toggle {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      position: absolute;\n      top: 1rem;\n      left: 1rem;\n      z-index: 5;\n      background: var(--bg-primary);\n      border: 1px solid var(--border-primary);\n      padding: 0.5rem 1rem;\n      border-radius: 8px;\n      font-weight: 600;\n      cursor: pointer;\n      box-shadow: var(--shadow-lg);\n    }\n  \n    /* Mobile Header inside Sidebar */\n    .sidebar-header-mobile {\n      display: block;\n      padding: 0 1.5rem 1rem;\n      border-bottom: 1px solid var(--border-primary);\n      margin-bottom: 1rem;\n    }\n    .sidebar-header-mobile h3 { margin: 0; font-size: 1.2rem; }\n  \n    /* Stack Grids */\n    .admin-stats { grid-template-columns: 1fr; }\n    .action-form-grid { grid-template-columns: 1fr; }\n    .action-form-grid .reason-group, .action-form-grid .action-button-container { grid-column: span 1; }\n    \n    /* Stack Header Elements */\n    .table-header {\n      flex-direction: column;\n      align-items: stretch;\n      gap: 1rem;\n    }\n    .search-bar input { width: 100%; }\n    \n    .date-range-container {\n      flex-direction: column;\n      align-items: stretch;\n    }\n    .admin-action-grid {\n      grid-template-columns: 1fr;\n    }\n  }\n  \n  /* Small Mobile (500px) */\n  @media (max-width: 500px) {\n    .admin-table-container { padding: 1rem; }\n    \n    /* Modal Adjustments */\n    .user-details-grid {\n      grid-template-columns: 1fr;\n      gap: 0.5rem;\n    }\n    .modal-actions {\n      flex-direction: column;\n    }\n    .modal-actions button {\n      width: 100%;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
